var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 202,
    viewBox: "0 0 251 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.75 0.874023H25.0833C11.2499 0.874023 0 12.1239 0 25.9574V176.457C0 190.291 11.2499 201.541 25.0833 201.541H225.75C239.583 201.541 250.833 190.291 250.833 176.457V25.9574C250.833 12.1239 239.583 0.874023 225.75 0.874023ZM56.4375 38.499C61.4269 38.499 66.2119 40.481 69.7399 44.0091C73.268 47.5371 75.25 52.3221 75.25 57.3115C75.25 62.3009 73.268 67.0859 69.7399 70.614C66.2119 74.142 61.4269 76.124 56.4375 76.124C51.4481 76.124 46.6631 74.142 43.135 70.614C39.607 67.0859 37.625 62.3009 37.625 57.3115C37.625 52.3221 39.607 47.5371 43.135 44.0091C46.6631 40.481 51.4481 38.499 56.4375 38.499ZM125.417 163.916H37.625L87.7917 101.207L106.604 126.291L144.229 76.124L213.208 163.916H125.417Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/AddImage.c3b6792e1f1cc2d704771ee7bb831d5f.svg";
export { ForwardRef as ReactComponent };